module.exports = __webpack_public_path__ + "static/assets/8fed622c4d818b24664982cc8590128c.png";